<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-release === ccr -->
      <div class="ccr">
        <div class="ccrp-content">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{index}}</div> -->
          <iSwitch size="large" v-model="Modal.isOpen">
            <span slot="open">ON</span>
            <span slot="close">OFF</span>
          </iSwitch>
          <!-- <span class="ccr-info">点击{{ Modal.isOpen ? '关闭' : '开启'}}商机</span> -->
          <span class="ccr-info">Business Opportunities</span>
          <div class="f-tar" style="margin-top:20px;">
            <Button type="primary" @click="saveCustom()" :loading="loading">Save</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  // 链接类型
  name: "custom-company-release",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "商机",
          type: 4,
          isOpen: true
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    currentSave(val, oldVal) {
      this.loading = val;
    }
  },
  computed: {
    type() {
      return this.Modal.config.type;
    },
    ...mapGetters({
      currentSave: "customCompanyModule/getCurrent",
      activeIndex: "customCompanyModule/getActiveIndex"
    })
  },
  created() {},
  methods: {
    ...mapMutations({
      setCurrent: "customCompanyModule/setCurrent",
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    saveCustom() {
      this.setCurrent(true);
    }
  }
};
</script> 
<style scoped lang="scss">
.ccr {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  min-height: 60px;
  .ccrp {
    &-title {
      padding: 20px 30px;
      font-size: 14px;
      color: #333;
      border-bottom: solid 1px #ddd;
    }
    &-content {
      padding: 40px 50px;
      .addlink {
        border: dashed 1px #bfbfbf;
        text-align: center;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
